<template>
  <div class="section notifications">
    <div class="container">
      <div class="columns is-centered">
        <div class="column is-half">
          <div class="section-block">
            <span class="title tw-text-black tw-uppercase"
              >My Notifications</span
            >
          </div>

          <div class="columns">
            <div class="column tw-text-right">
              <b-button
                v-if="
                  notifications.data &&
                    notifications.meta.total !== 0 &&
                    notifications.data.length !== 0
                "
                @click.prevent="markAllAsRead()"
                type="is-primary"
                size="sm"
                class="tw-text-sm"
                :disabled="isSubmitting || isAllRead"
                :loading="isSubmitting"
                >Mark all as read</b-button
              >
            </div>
          </div>

          <skeleton-loading v-if="isLoading" />
          <div class="list-group">
            <div
              v-for="(notification, index) in notifications.data"
              :key="notification + index"
              :class="[
                'columns group-item is-flex',
                {
                  '--unread': setUnreadStatus(notification),
                  '--unread-admin':
                    (notification.type === 'admin' ||
                      notification.type === 'message_leaders') &&
                    !notification.read,
                  '--unread-event':
                    notification.type === 'event' && !notification.read
                }
              ]"
            >
              <div class=" is-one-fifth is-one-fifth-mobile item --icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  :class="[
                    'tw-mx-auto',
                    {
                      'tw-text-post-prayer tw-h-5 tw-w-5':
                        notification.type === 'admin' &&
                        notification.type === 'message_leaders',
                      'tw-text-post-idea tw-h-5 tw-w-5':
                        notification.type === 'event',
                      'tw-h-6 tw-w-6':
                        (notification.type !== 'admin' ||
                          notification.type !== 'message_leaders') &&
                        notification.type !== 'event'
                    }
                  ]"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <template v-if="notification.type === 'comment'">
                    <title>Comment</title>
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
                    />
                  </template>
                  <template v-if="notification.type === 'group_notice'">
                    <title>Groups</title>
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                    />
                  </template>
                  <template v-if="notification.type === 'post'">
                    <title>Student Hub</title>
                    <path d="M12 14l9-5-9-5-9 5 9 5z" />
                    <path
                      d="M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z"
                    />
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M12 14l9-5-9-5-9 5 9 5zm0 0l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14zm-4 6v-7.5l4-2.222"
                    />
                  </template>
                  <template v-if="notification.type === 'news'">
                    <title>News</title>
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z"
                    />
                  </template>
                  <template
                    v-if="
                      notification.type === 'resource' ||
                        notification.type === 'lunchtime-resource'
                    "
                  >
                    <title>Training Resources</title>
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
                    />
                  </template>
                  <template v-if="notification.type === 'admin'">
                    <title>Admin</title>
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                    />
                  </template>
                  <template v-if="notification.type === 'message_leaders'">
                    <title>Message Leaders</title>
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                    />
                  </template>
                  <template v-if="notification.type === 'event'">
                    <title>Event</title>
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                    />
                  </template>
                  <template v-if="notification.type === 'blog'">
                    <title>Blog</title>
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                    />
                  </template>
                </svg>
              </div>
              <div class="item --text">
                <template v-if="notification.type === 'admin'">
                  <b-collapse
                    :open="false"
                    @open="routeToActivity(notification)"
                  >
                    <template #trigger="props1">
                      <b-icon
                        :icon="props1.open ? 'chevron-down' : 'chevron-up'"
                        size="is-small"
                        class="tw-text-post-prayer tw-mr-2"
                      >
                      </b-icon>
                      <a @click.prevent class="tw-text-post-prayer"
                        >Message from Admin</a
                      >
                    </template>
                    <div class="tw-mt-5 tw-pt-3 item-dropdown">
                      {{ notification.message }}
                    </div>
                  </b-collapse>
                </template>
                <template v-else-if="notification.type === 'message_leaders'">
                  <b-collapse
                    :open="false"
                    @open="routeToActivity(notification)"
                  >
                    <template #trigger="ml">
                      <b-icon
                        :icon="ml.open ? 'chevron-down' : 'chevron-up'"
                        size="is-small"
                        class="tw-text-post-prayer tw-mr-2"
                      >
                      </b-icon>
                      <a @click.prevent class="tw-text-post-prayer"
                        >{{ notification.header }}
                      </a>
                    </template>
                    <div class="tw-mt-5 tw-pt-3 item-dropdown">
                      {{ notification.message }}
                    </div>
                  </b-collapse>
                </template>
                <template v-else-if="notification.type === 'event'">
                  <b-collapse
                    :open="false"
                    @open="routeToActivity(notification)"
                  >
                    <template #trigger="props2">
                      <b-icon
                        :icon="props2.open ? 'chevron-down' : 'chevron-up'"
                        size="is-small"
                        class="text-post-idea-dark tw-mr-2"
                      >
                      </b-icon>
                      <a
                        class="text-post-idea-dark tw-capitalize"
                        @click.prevent
                        >Upcoming
                        {{
                          notification.event.type === 'group'
                            ? notification.event.type
                            : 'Mustard'
                        }}
                        Event</a
                      >
                    </template>
                    <div class="tw-mt-5 tw-pt-3 item-dropdown">
                      <p class="tw-capitalize">
                        <strong>Event:</strong> {{ notification.event.name }}
                      </p>
                      <p>
                        <strong>Description:</strong>
                        {{ notification.event.description }}
                      </p>
                      <p>
                        <strong>Date:</strong>
                        {{
                          formatEventDate(notification.event.start_at, 'MMMM D')
                        }}
                        <span
                          v-if="
                            notification.event.end_at &&
                              notification.event.is_recurring
                          "
                        >
                          -
                          {{
                            formatEventDate(notification.event.end_at, 'MMMM D')
                          }}</span
                        >
                      </p>
                      <p v-if="!notification.event.is_all_day">
                        <strong>Time:</strong>
                        {{ formatEventTime(notification.event.start_at, 'LT') }}
                        <span v-if="notification.event.is_recurring">
                          -
                          {{
                            formatEventTime(notification.event.end_at, 'LT')
                          }}</span
                        >
                      </p>
                    </div>
                  </b-collapse>
                </template>
                <a
                  v-else
                  class="tw-cursor-pointer"
                  @click="routeToActivity(notification)"
                  >{{ notification.message }}</a
                >
              </div>
              <div
                class=" is-one-fifth is-one-fifth-mobile item --date"
                :title="formatDate(notification.created_at)"
              >
                {{ fromNow(notification.created_at) }}
              </div>
            </div>
            <b-pagination
              class="tw-mt-8"
              v-if="notifications.meta.total !== 0"
              @change="onPageChanged"
              :total="notifications.meta.total"
              :current.sync="notifications.meta.current_page"
              :per-page="notifications.meta.per_page"
              order="is-centered"
              aria-next-label="Next page"
              aria-previous-label="Previous page"
            >
            </b-pagination>
            <div class="tw-text-gray-200 tw-text-center" v-else>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="tw-h-6 tw-w-6 tw-m-auto"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
                />
              </svg>
              You have no notifications yet
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { forEach } from 'lodash'
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
  metaInfo: {
    title: 'Notifications'
  },
  data() {
    return {
      isAllRead: false,
      isLoading: false,
      isSubmitting: false,
      notifications: {
        meta: {
          current_page: 1,
          per_page: 15
        }
      }
    }
  },
  async mounted() {
    this.isLoading = true
    await this.getNotifications()
    await this.setCalendarTimezone(dayjs.tz.guess())
  },
  computed: {
    ...mapState({
      calendarOptions: state => state.calendar.options
    })
  },
  methods: {
    ...mapActions({
      getUnreadNotifications: 'getUnreadNotifications'
    }),
    ...mapMutations(['setCalendarTimezone']),

    formatDate(date) {
      return dayjs(date).format('DD/MM/YY HH:mm:ss Z UTC')
    },
    formatEventDate(date, format) {
      return dayjs(date)
        .tz(this.calendarOptions.timeZone)
        .format(format)
    },
    formatEventTime(time, format) {
      return dayjs(time)
        .tz(this.calendarOptions.timeZone)
        .format(format)
    },
    fromNow(date) {
      return dayjs(date).fromNow()
    },
    async getNotifications() {
      await this.$api
        .get(
          `/notifications?limit=${this.notifications.meta.per_page}&page=${this.notifications.meta.current_page}&filter[type_exclude]=message_leaders`
        )
        .then(({ data }) => {
          this.notifications = data
          this.checkAllNotifAsRead()
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    async routeToActivity(notification) {
      switch (notification.type) {
        case 'comment':
          await this.markNotifAsRead(notification.id)
          let ctype = await this.checkCommentType(notification.commentable_type)
          this.$router.push({ path: `/${ctype}/${notification.model_id}` })
          break
        case 'group_notice':
          await this.markNotifAsRead(notification.id)
          this.$router.push({ path: `/groups/noticeboard` })
          break
        case 'post':
          await this.markNotifAsRead(notification.id)
          this.$router.push({ path: `/student-hub/${notification.model_id}` })
          break
        case 'news':
          await this.markNotifAsRead(notification.id)
          this.$router.push({ path: `/news/${notification.model_id}` })
          break
        case 'resource':
          await this.markNotifAsRead(notification.id)
          this.$router.push({
            path: `/training/resources/${notification.slug}`
          })
          break
        case 'lunchtime-resource':
          await this.markNotifAsRead(notification.id)
          this.$router.push({
            path: `/resources/${notification.slug}`
          })
          break
        case 'admin':
          await this.markNotifAsRead(notification.id)
          this.getNotifications()
          break
        case 'message_leaders':
          await this.markNotifAsRead(notification.id)
          this.getNotifications()
          break
        case 'event':
          await this.markNotifAsRead(notification.id)
          this.getNotifications()
          break
        case 'blog':
          await this.markNotifAsRead(notification.id)
          this.$router.push({
            path: `/training/blogs/${notification.model_id}`
          })
          break
      }
    },
    async markNotifAsRead(id) {
      await this.$api.post(`/notifications/${id}/read`)
      this.getUnreadNotifications()
    },
    async markNotifAsUnread(id) {
      await this.$api.post(`/notifications/${id}/unread`)
      this.getUnreadNotifications()
    },
    async markAllAsRead() {
      this.isSubmitting = true
      await this.$api
        .post(
          `/notifications/mark-all-read?filter[type_exclude]=message_leaders`
        )
        .then(() => {
          this.getNotifications()
          this.getUnreadNotifications()
        })
        .finally(() => {
          this.isSubmitting = false
        })
    },
    async onPageChanged(page) {
      this.notifications.meta.current_page = page
      await this.getNotifications()
      await this.getUnreadNotifications()
    },
    setUnreadStatus(notification) {
      if (notification.read) {
        return false
      } else {
        return (
          notification.type !== 'admin' &&
          notification.type !== 'event' &&
          notification.type !== 'message_leaders'
        )
      }
    },
    checkCommentType(ctype) {
      switch (ctype) {
        case 'posts':
          return 'student-hub'
        case 'blogs':
          return 'news'
        case 'resource_videos':
          return 'resources'
        case 'groups':
          return 'groups'
      }
    },
    checkAllNotifAsRead() {
      forEach(this.notifications.data, data => {
        this.isAllRead = data.read
        if (!data.read) {
          return false
        }
      })
    }
  }
}
</script>

<style></style>
